import { render, staticRenderFns } from "./AsCollFromExamList.vue?vue&type=template&id=8ef8b156&scoped=true&"
import script from "./AsCollFromExamList.vue?vue&type=script&lang=js&"
export * from "./AsCollFromExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef8b156",
  null
  
)

export default component.exports